import ApiBase from '../api-base'
import { ACTIVE_BASE_REST } from '../constants'

export default class TransportCredential extends ApiBase {
  constructor(store) {
    super(store, `${ACTIVE_BASE_REST}/credential`)
  }

  confirm(id, data, showProgress) {
    return this._request({
      action: `${id}/confirm`,
      method: 'PATCH',
      body: data,
      showProgress
    })
  }
}
